import styles from '@/styles/category/latest-reviews.module.scss'
import { useState, useEffect } from 'react'
import Link from 'next/link'
import Image from 'next/image'
import { Rate, Pagination, Select } from 'antd'
import type { PaginationProps } from 'antd';
import categoryApi from '@/service/modules/categoryApi'

interface Props {
  categoryId: number | string;
}

export default function CategoryLatestReviews({ categoryId }: Props) {
  const { Option } = Select

  interface reviewItem {
    reviewID: number;
    productID: number;
    rate: number;
    customerName: string;
    createTime: string;
    detail: string;
    product: {
      name: string;
      url: string;
      filename: string;
    }
  }

  const [avgRank, setAvgRank] = useState(5)
  const [reviewsData, setReviewsData] = useState<reviewItem[]>([]);
  const [currentPage, setCurrentPage] = useState(1)
  const [pageSize, setPageSize] = useState(6)
  const [total, setTotal] = useState(0)

  // 获取分类商品review数据
  async function getCategoryReviewsData() {
    try {
      let dataObj = {
        categoryId,
        page: currentPage,
        perPage: pageSize,
        sortBy: 'reviewID',
        sortDirection: 'desc'
      }

      // 匹配 Filter by 参数
      switch (sortBy) {
        case '1':
          dataObj.sortBy = 'reviewID'
          dataObj.sortDirection = 'desc'
          break
        case '2':
          dataObj.sortBy = 'reviewID'
          dataObj.sortDirection = 'asc'
          break
        case '3':
          dataObj.sortBy = 'rate'
          dataObj.sortDirection = 'desc'
          break
        case '4':
          dataObj.sortBy = 'rate'
          dataObj.sortDirection = 'asc'
          break
        case '5':
          dataObj.sortBy = 'scores'
          dataObj.sortDirection = 'desc'
          break
        default:
          dataObj.sortBy = 'reviewID'
          dataObj.sortDirection = 'desc'
      }

      let resData = await categoryApi.getCategoryReviews(dataObj)

      if (resData.data && resData.data.pageList && resData.data.pageList.total) {
        setReviewsData(resData.data.pageList.items)

        setAvgRank(resData.data.avgRank)
        setCurrentPage(resData.data.pageList.currentPage)
        setPageSize(resData.data.pageList.perPage)
        setTotal(resData.data.pageList.total)
      }
    } catch (error) {
      console.log(`csotd数据获取失败： `, error)
    }
  }

  // 分页器
  const onChange: PaginationProps['onChange'] = (current) => {
    setCurrentPage(current)
  };

  interface suburbOptionsItem {
    id: string;
    name: string
  }
  const [suburbOptions, setSuburbOptions] = useState<suburbOptionsItem[]>([]);
  const [sortBy, setSortBy] = useState('5')

  useEffect(() => {
    setSuburbOptions(
      [
        { id: '1', name: 'Date - Newest First' },
        { id: '2', name: 'Date - Oldest First' },
        { id: '3', name: 'Rating - High to Low' },
        { id: '4', name: 'Rating - Low to High' },
        { id: '5', name: 'Helpfulness - Hight to Low' }
      ]
    )
  }, [])

  // Filter by选择器触发事件
  const handleChangeSort = (value: string) => {
    setSortBy(value)
  };

  useEffect(() => {
    getCategoryReviewsData()
  }, [currentPage, sortBy])

  return (
    <div>
      {
        !!(categoryId && reviewsData && reviewsData.length) &&
        <div className={styles['comp-latest-reviews']}>
          <Link
            href={`/holiday-deals/reviews/`}
            legacyBehavior
          >
            <a rel="noopener noreferrer" style={{ display: 'block' }}>
              <div className={styles['title']}>Latest Holiday Deals Reviews</div>
            </a>
          </Link>

          <div className={styles['reviews-desc']}>
            <Rate style={{ fontSize: '16px', color: '#ffc33d' }} allowHalf disabled value={5} />
            <div className={styles['reviews-num']}>{avgRank} out of 5</div>
            <div className={styles['reviews-count']}>
              from <span className={styles['count-num']}>{total} reviews</span>
            </div>
          </div>

          {
            reviewsData.map((item: reviewItem) => (
              <div className={styles['review-item']} key={item.reviewID}>
                <Link
                  href={item.product.url || '/'}
                  legacyBehavior
                >
                  <a rel="noopener noreferrer">
                    <Image
                      className={styles['product-img']}
                      src={item.product.filename || ''}
                      alt={item.product.name || ''}
                      width={150}
                      height={150}></Image>
                  </a>
                </Link>

                <div className={styles['review-info']}>
                  <Link
                    href={item.product.url || ''}
                    legacyBehavior
                  >
                    <a rel="noopener noreferrer">
                      <div className={styles['product-name']}>{item.product.name}</div>

                      <div className={styles['review-line']}>
                        <div className={styles['rate']}>
                          <Rate style={{ fontSize: '16px', color: '#ffc33d', marginRight: '8px' }} allowHalf disabled value={item.rate} />
                          {item.rate} stars
                        </div>

                        <div className={styles['customer-name']}>By <b>{item.customerName}</b></div>

                        <div className={styles['create-time']}>on {item.createTime}</div>
                      </div>
                    </a>
                  </Link>

                  <Link
                    href={`/product/${item.productID}/reviews_${item.reviewID}.html`}
                    legacyBehavior
                  >
                    <a rel="noopener noreferrer">
                      <div className={styles['review-desc']}>{item.detail}</div>
                    </a>
                  </Link>
                </div>
              </div>
            ))
          }
          
          <div className={styles['pagination-box']}>
            {/* 分页器 */}
            <Pagination
              showQuickJumper
              showSizeChanger={false}
              onChange={onChange}
              defaultCurrent={currentPage}
              defaultPageSize={pageSize}
              total={total}
            /> 
            
            <div className={styles['select-filter-item']}>
              Sort by: &nbsp;
              <Select 
                onChange={handleChangeSort} 
                size={'small'}
                style={{ width: '240px' }}
                defaultValue={sortBy}
              >
                {
                  !!(suburbOptions && suburbOptions.length) &&

                  suburbOptions.map((item: suburbOptionsItem) => (
                    <Option 
                      value={item.id}
                      key={item.id}
                    >
                      {item.name}
                    </Option>
                  ))
                }
              </Select>
            </div>
          </div>
        </div>
      }
    </div>
  )
}